import { useQuery } from '@tanstack/react-query';

import useMerchant from './useMerchant';

//
//

interface Params {
  key: string;
  fetchFunction: any;
  params: {
    programmeCode?: string;
    merchantCode?: string;
  };
}

const useReportData = ({ key, fetchFunction, params }: Params, enabled?: boolean) => {
  const { merchant } = useMerchant();
  const queryKey = [key, params];

  return useQuery({
    queryKey: queryKey,
    queryFn: () => fetchFunction(params),
    staleTime: 30000, // Data considered fresh for 30 seconds
    refetchOnWindowFocus: false, // Don't refetch data when window gains focus
    enabled: !!merchant?.code && enabled,
  });
};

export default useReportData;
